import React from 'react';

import {
  IconButton,
  Link,
  EditIcon,
  Stack,
  Typography,
  styled,
} from '@gogame/components';
import { DateRangeFormatter, NumberValueFormatter } from '@gogame/intl-ts';

import { StatusIndicator } from 'scenes/Campaigns/components/shared';

const TypeWrapper = styled('span')`
  margin-right: 4px;
`;
const CostModelsRateItem = ({ value, column, row }) => {
  const { period, rate, isReadonly, type, pendingChanges } = value;
  const { onEditCostModelRate, onOpenSpendAdjustment } = column;
  const handleOnEdit = () => {
    onEditCostModelRate({ id: type.id, campaignId: row.id });
  };

  const handleOpenSpendAdjustment = () => {
    onOpenSpendAdjustment({ id: pendingChanges.spendAdjustmentId });
  };
  const rateValue = (
    <NumberValueFormatter.Currency
      value={rate.value}
      currency={rate.currency}
      precision={2}
    />
  );
  const editable = row?.actions?.includes('edit');

  const _cellValue = row?.[column.field];

  return (
    <Stack
      direction={'row'}
      as={'span'}
      justifyContent={'space-between'}
      alignItems={'center'}
      spacing={1}
    >
      <Stack
        as={'span'}
        alignItems={'flex-end'}
        sx={{ minWidth: 0, flexGrow: 1 }}
      >
        <Typography variant={'inherit'} align={'right'} as={'span'}>
          {_cellValue?.length > 1 ? (
            <TypeWrapper>{value?.type.name}</TypeWrapper>
          ) : null}
          {isReadonly ? (
            <span>
              <StatusIndicator status={'pending'} />
              <Link onClick={handleOpenSpendAdjustment}>{rateValue}</Link>
            </span>
          ) : (
            rateValue
          )}
        </Typography>

        <Typography
          variant={'inherit'}
          sx={{ fontSize: 10, letterSpacing: 0, maxWidth: '100%' }}
          as={'span'}
          noWrap
          disableTooltip
        >
          <DateRangeFormatter
            value={period}
            template={'LL'}
            dataRangePlaneText={true}
          />
        </Typography>
      </Stack>
      <IconButton
        icon={<EditIcon />}
        tooltip={'Edit Cost Model'}
        onClick={handleOnEdit}
        disabled={!editable}
      />
    </Stack>
  );
};

export default CostModelsRateItem;
